import { FormlyFieldConfig } from '@ngx-formly/core';
import { IApplicationFormData } from '../../ui/models/application-form-data.model';
import { IServiceTranslation } from '../../ui/models/service-translation.model';
import { TranslateService } from '@ngx-translate/core';

// Define different function signatures for the build preview data functions
export type BuildPreviewDataFn = {
  // Signature for applicationFormBuildPreviewData
  (
    layout: FormlyFieldConfig[],
    layoutData: Record<string, unknown>,
    addLabelCount?: boolean
  ): IApplicationFormData[];

  // Signature for applicationFormBuildPreviewDataTranslated
  (
    layout: FormlyFieldConfig[],
    layoutData: Record<string, unknown>,
    serviceTranslations?: IServiceTranslation,
    addLabelCount?: boolean,
    translateService?: TranslateService
  ): IApplicationFormData[];
};

/**
 * Cleans service data by removing __formLayout property
 */
export const cleanServiceData = (
  serviceData: Record<string, unknown>
): Record<string, unknown> => {
  const cleanedData = { ...serviceData };
  delete cleanedData['__formLayout'];
  return cleanedData;
};
